import React from 'react'
import './home-css/sectionfour.css'
const SectionFour = () => {
  return (
    <div className='section-four-container'>
      <div className='section-four secFour-grid-system'>
        <div className='sec-four-text'>
          Get a 20% off on your first month<br/>of membership
        </div>
      </div>
      
      </div>
  )
}

export default SectionFour